import { format, formatISO, isValid, parse, parseISO } from "date-fns";
import { fullDateLongFormat } from "@common/helpers/date";
import { addTimeZoneOffset } from "@helpers/date";

const ISO_DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function formatAccrualImporterDate(
    date: Date | string | null | undefined,
): string {
    if (!date) {
        return "";
    }
    if (typeof date === "string" && ISO_DATE_ONLY_PATTERN.test(date)) {
        const parsed = parse(date, "yyyy-MM-dd", new Date());
        if (!isValid(parsed)) {
            return "";
        }
        return format(parsed, fullDateLongFormat);
    }
    const parsed = typeof date === "string" ? parseISO(date) : date;
    if (!isValid(parsed)) {
        return "";
    }
    return format(addTimeZoneOffset(parsed), fullDateLongFormat);
}

export function parseAccrualImporterDateToIso(value: string): string | null {
    if (!value) {
        return null;
    }
    const parsed = parse(value, fullDateLongFormat, new Date());
    if (Number.isNaN(parsed.getTime())) {
        return null;
    }
    return formatISO(parsed, { representation: "date" });
}
